import moment from 'moment';
import { getCardType, checkCreditCard } from './creditCardValidation.utils';

export class ValidationUtils {
    public static isEmail(email: string): boolean {
        const regex = new RegExp(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
        return regex.test(String(email).toLowerCase());
    }

    public static isEmptyOrWhiteSpace(value: string): boolean {
        const regex = new RegExp(/^\s*$/);
        const isWhiteSpace = regex.test(value);
        const isEmpty = value === '';
        return isEmpty || isWhiteSpace;
    }

    public static isValidExpirationMonth(month: string, year: string): boolean {
        const now = moment();
        return +year > now.year() || (+year === now.year() && +month > now.month());
    }

    public static isValidExpirationYear(value: string): boolean {
        const now = moment();
        return +value >= now.year();
    }

    public static isValidCreditCard(cardNumber: string): boolean {
        const card = getCardType(cardNumber);
        return checkCreditCard(cardNumber, card.type);
    }

    public static validateAndGetEnvVar(variable: string): string {
        const value = process.env[variable];
        if (!value || ValidationUtils.isEmptyOrWhiteSpace(value)) {
            const message = `Variable ${variable} is undefined, empty or white space`;
            throw new Error(message);
        }

        return value;
    }

    public static isValidGuestForm = (guest: { firstName: string; lastName: string; email: string }) => {
        let isValid = true;

        if (!ValidationUtils.isEmail(guest.email) || ValidationUtils.isEmptyOrWhiteSpace(guest.email)) {
            isValid = false;
        }
        if (ValidationUtils.isEmptyOrWhiteSpace(guest.firstName)) {
            isValid = false;
        }
        if (ValidationUtils.isEmptyOrWhiteSpace(guest.lastName)) {
            isValid = false;
        }

        return isValid;
    };

    public static getDomain(): string {
        const environment = process.env.REACT_APP_CUSTOM_NODE_ENV;
        switch (environment) {
            case 'production': {
                return 'vacasa.com';
            }

            case 'local': {
                return 'localhost';
            }

            default: {
                return 'vacasastage.com';
            }
        }
    }

    public static getCookieDomain() {
        const domain = this.getDomain();
        if (domain === 'localhost') {
            return '.app.localhost';
        }
        return `.${domain}`;
    }

    public static isEnterOrSpaceKey = (key: number) => {
        return key === 13 || key === 32;
    };
}
